import React from 'react';
import BaseTestCard from '../BaseTestCard/BaseTestCard';
import TestSelectionFormFieldNames from '../../../../../../Models/TestSelectionFormFieldNames';
import TestInfo from '../../../../../../../../Models/TestInfo';
import UIStrings from '@/Utils/UIStrings';
import { resourceBaseUrl } from '@/AppSettings';
import { PreviewQuestionsProps } from '../PreviewQuestions/Dialog/usePreviewQuestions';

interface AptitudeTestCardProps extends Omit<PreviewQuestionsProps, 'testType'> {
    test: TestInfo;
}

function AptitudeTestCard({ test, demoQuestions, likertOptions }: AptitudeTestCardProps): React.JSX.Element {
    return (
        <BaseTestCard
            {...test}
            testName={UIStrings.Aptitude}
            fieldName={TestSelectionFormFieldNames.isAptitudeSelected}
            imageURL={`${resourceBaseUrl}/images/Aptitude.png`}
            demoQuestions={demoQuestions}
            likertOptions={likertOptions}
        />
    );
}

export default AptitudeTestCard;
